import { RootState } from "@/modules/common";

export const selectCanUseBalance = (state: RootState) =>
  state.basket.basket.canUseBalance &&
  state.customers.data &&
  state.customers.data?.balance > 0;
